import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { switchMap, tap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ArticalManagementService } from './artical-management.service';
import { ModalArticalPollComponent } from './modal-artical-poll/modal-artical-poll.component';

@Component({
  selector: 'app-artical-management',
  templateUrl: './artical-management.component.html',
  styleUrls: ['./artical-management.component.scss']
})
export class ArticalManagementComponent implements OnInit {
  allArtical: any;
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchArtical: any = '';
  locationUrl: string = window.location.origin;
  alwaysOpen: boolean = true;

  column = [{
    field: 'ARTICAL_ID',
    header: 'รหัสบทความ',
    style: 'col'
  }, {
    field: 'ARTICAL_TITAL',
    header: 'ชื่อบทความ',
    style: 'col'
  }, {
    field: 'ARTICAL_CATEGORY',
    header: 'ประเภทบทความ',
    style: 'col'
  }, {
    field: 'ARTICAL_START',
    field2: 'ARTICAL_END',
    header: 'วัน เวลาเปิด/ปิดบทความ',
    style: 'col'
  }, {
    field: 'POLL_ID',
    header: 'ผลโหวต',
    style: 'col-1'
  }, {
    field: 'ARTICAL_READED',
    header: 'จำนวนผู้อ่าน',
    style: 'col-1'
  }, {
    field: 'ARTICAL_STATUS',
    header: 'สถานะ',
    style: 'col-1'
  }, {
    field: 'CREATE_NAME',
    header: 'ผู้เขียนบทความ',
    style: 'col-1'
  }, {
    field: 'EDIT',
    header: 'แก้ไข',
    style: 'col-1'
  }]

  constructor(
    public matDialog: MatDialog,
    private articalManagementService: ArticalManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.getAllArtical();
    this.gobalFunctionService.setTitle('การจัดการบทความ');
  }

  addArtical() {
    window.open('/article-management/manage-article?isEdit=false', '_blank');
  }

  getAllArtical() {
    this.articalManagementService.getAllArtical().subscribe(res => {
      // // console.log(res);

      this.allArtical = res.result;
      this.refresh();
    });
  }

  edit(row) {
    window.open('/article-management/manage-article?isEdit=true&article_id=' + row.ARTICAL_ID, '_blank');
  }

  poll(row) {
    // // console.log(row);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalPoll';
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `${row.ARTICAL_ID} : ${row.ARTICAL_TITAL}`,
      articalId: row.ARTICAL_ID,
      row: row
    }

    const modal = this.matDialog.open(ModalArticalPollComponent, dialogConfig);
    modal.afterClosed().subscribe()
  }

  changeStatus(event, artical) {
    const dialogConfig = new MatDialogConfig();
    let body;

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';

    if (artical.ARTICAL_STATUS) {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการเปิดสถานะการมองเห็น ผู้ใช้จะสามารถเห็นบทความได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        ARTICAL_ID: artical.ARTICAL_ID,
        ARTICAL_STATUS: 0
      }
    } else {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการปิดสถานะการมองเห็น ผู้ใช้จะไม่สามารถเห็นบทความได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        ARTICAL_ID: artical.ARTICAL_ID,
        ARTICAL_STATUS: 1
      }
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res) {
        this.articalManagementService.updateStatusArtical(body).pipe(
          switchMap(() => {
            event.source.checked = artical.ARTICAL_STATUS;
            return this.articalManagementService.getAllArtical();
          })
        ).subscribe();
      } else {
        event.source.checked = !artical.ARTICAL_STATUS;
      }
    })
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchArtical = [];
      this.allArtical.filter(artical => {
        if (artical.ARTICAL_TITAL.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchArtical.push(artical)
        }
      });
      this.refreshSearch();
    } else {
      this.isSearch = false
      this.searchArtical = null;
      this.getAllArtical();
    }
  }

  refresh() {
    this.collectionSize = this.allArtical.length;
    this.rows = this.allArtical
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  refreshSearch() {
    this.collectionSize = this.searchArtical.length;
    this.rows = this.searchArtical
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
